module.exports = __webpack_public_path__ + "img/DW365-280.071cf20d.jpg";